import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import { login } from '../services/api';

const AdminLogin = ({ setToken }) => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [message, setMessage] = useState('');

    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        try {
            const response = await login(username, password);
            console.log(response);
            const token = response.data.access_token;
            setToken(token);
            localStorage.setItem('adminToken', token);

            const decodedToken = jwtDecode(token);
            localStorage.setItem('adminId', decodedToken.sub);
            localStorage.setItem('adminUsername', decodedToken.preferred_username);

            // Extract Keycloak client roles using azp avoiding unreliable Object.keys() ordering across environments
            const resourceAccess = decodedToken.resource_access || {};
            const clientRoles = resourceAccess[decodedToken.azp]?.roles || [];
            localStorage.setItem('adminRoles', JSON.stringify(clientRoles));

            console.log('Login successful. Roles:', clientRoles);
            setMessage('Login successful!');
            navigate('/home');
        } catch (error) {
            setMessage('Login failed: ' + (error.response?.data?.message || error.message));
        }
    };

    useEffect(() => {
        const token = localStorage.getItem('adminToken');

        if (token) {
            try {
                const decodedToken = jwtDecode(token);
                const currentTime = Math.floor(Date.now() / 1000);
                const timeLeft = decodedToken.exp - currentTime;
                if (timeLeft > 2 * 60 * 60) {
                    navigate('/api-keys');
                } else {
                    localStorage.removeItem('adminToken');
                    setToken(null);
                    alert('Your session is about to expire. Please login again.');
                    navigate('/');
                }
            } catch (error) {
                console.error('Invalid token:', error);
                localStorage.removeItem('adminToken');
                setToken(null);
                navigate('/');
            }
        } else {
            // No token found
            setToken(null);
            navigate('/');
        }
    }, []);

    return (
        <div className="container mt-5">
            <div className="row justify-content-center">
                <div className="col-md-6">
                    <h2 className="text-center mb-4">Admin Login</h2>
                    {message && (
                        <div className="alert alert-info" role="alert">
                            {message}
                        </div>
                    )}
                    <form onSubmit={handleLogin}>
                        <div className="mb-3">
                            <label htmlFor="username" className="form-label">
                                Username
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                id="username"
                                placeholder="Enter username"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                            />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="password" className="form-label">
                                Password
                            </label>
                            <input
                                type="password"
                                className="form-control"
                                id="password"
                                placeholder="Enter password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                        </div>
                        <div className="d-grid">
                            <button type="submit" className="btn btn-primary">
                                Login
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default AdminLogin;
